import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive, useDeviceType } from '@cian/ui-kit';

import { CompilationHeaderLayout } from '../../../components/redesign/CompilationHeaderLayout';
import { HeaderLayout } from '../../../components/redesign/HeaderLayout';
import { selectIsCompilation } from '../../../selectors/compilation';
import { BackButtonContainer } from '../../BackButton';
import { ChipsContainer } from '../../Chips';
import { CounterContainer } from '../../CounterContainer';
import { FakeSearchInputContainer } from '../../FakeSearchInput';
import { SortingContainer } from '../../SortingContainer';
import { PageDescriptionContainer } from '../PageDescriptionContainer';
import { PageTitleContainer } from '../PageTitleContainer';
import { PromoCategoryPlateContainer } from '../PromoCategoryPlateContainer';

export const HeaderContainer: React.FC = () => {
  const isPhone = useDeviceType() === 'phone';

  const isCompilation = useSelector(selectIsCompilation);

  if (isCompilation) {
    return (
      <CompilationHeaderLayout
        title={<PageTitleContainer />}
        description={<PageDescriptionContainer isCompilation={true} />}
      />
    );
  }

  return (
    <HeaderLayout
      backButton={isPhone && <BackButtonContainer />}
      title={<PageTitleContainer />}
      description={
        <Responsive desktop tablet>
          <PageDescriptionContainer isCompilation={false} />
        </Responsive>
      }
      sorting={<SortingContainer />}
      fakeSearchInput={<FakeSearchInputContainer />}
      chips={<ChipsContainer />}
      counter={<CounterContainer />}
      promoCategoryPlate={<PromoCategoryPlateContainer />}
    />
  );
};
